<template>
  <div class="batch-enter-store">
    <van-popup v-model:show="visiable" round position="bottom" v-if="visiable">
      <div class="tool-bar" style="overflow: hidden;padding: 2px 10px;">
        <div 
          style="float: left;padding: 10px 15px;color: #969799;"
          @click="cancel"
        >取消</div>
        <div
          style="float: right;padding: 10px 15px;color: #576b95;"
          @click="confirm"
        >确定</div>
      </div>

     
      <div class="sku-list" style="min-height: 390px;">
        <div class="sku-item" v-for="(v, i) in val">
          <div class="sku-item-left">
            <span>{{ skuMap[v.id] }}</span><br>
            <span style="font-size: 14px;color: rgb(95, 99, 104);">{{ warehouseMap[v.warehouse_id] }}</span>
          </div>
          <div class="sku-item-right">
            {{ v.storageing }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: [Object],
      default: () => {
        return [];
      }
    },
    visiable: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    warehouseList: {
      type: [Array],
      default: () => {
        return [];
      }
    },
  },
  data() {
    return {
      val: [],
      warehouseMap: {},
      skuMap: {},
    };
  },
  watch: {
    value: {
      handler: function(newv, oldv) {
        // 过滤掉空的
        this.val = Object.keys(this.value).filter((key) => { return this.value[key].storageing > 0 && this.value[key].warehouse_id > 0 }).map((key) => { return this.value[key]; });

        if (this.val.length > 0) {
          this.warehouseList.forEach((item) => {
            this.warehouseMap[item.warehouse_id] = item['warehouse_name'];
          })

          this.orderInfo.items.forEach((item) => {
            this.skuMap[item.id] = item['sku'];
          })
        }
       
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    init() {},
    cancel() {
      this.$emit('update:visiable', false);
    },
    confirm() {
      this.$emit('confirm', 0, this.val);
      this.$emit('update:visiable', false);
    },
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.sku-list {
  padding: 10px 25px;

  .sku-item {
    overflow: hidden;
    border-bottom:  1px solid rgb(189, 186, 186);
    padding-left: 15px;

    .sku-item-left {
      float: left;
      font-size: 18px;
      padding: 10px 0px;
    }

    .sku-item-right {
      float: right;
      font-size: 20px;
      color: rgb(64, 158, 255);
      line-height: 40px;
      padding: 10px 15px;
    }
  }
}

</style>
